module.exports = __webpack_public_path__ + "media/src/images/list_01-c8ee027257ba3a6bfd70fb72b5f91732.gif";